import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { AssociarUserTerceiroGrupoService } from './associar-user-terceiro-grupo.service';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';

@Component({
  selector: 'ngx-associar-user-terceiro-grupo',
  templateUrl: './associar-user-terceiro-grupo.component.html',
  styleUrls: ['./associar-user-terceiro-grupo.component.scss']
})
export class AssociarUserTerceiroGrupoComponent implements OnInit {

  public spinnerLoad: boolean = false;

  public formMenusGrupo: FormGroup = null;
  public grupoId: any = null;
  public grupoDescription: any = null;
  public produtoId: any = null;

  public listUsers: any = [];

  public listUsersGroup: any = [];
  public customLogin = null;

  constructor(
    private route: ActivatedRoute,
    private notifications: NotificationsService,
    private formBuilder: FormBuilder,
    private service: AssociarUserTerceiroGrupoService,
    private encriptyService: EncriptyUtilService,
    private location: Location
  ) {

    this.route.queryParamMap.subscribe(params => {
      this.grupoId = this.encriptyService.decriptyBySecretKey(params.get('grupoId'))
      this.produtoId = this.encriptyService.decriptyBySecretKey(params.get('produtoId'))
    });

    this.formMenusGrupo = this.formBuilder.group({
      grupoId: [this.grupoId],
      produtoId: [this.produtoId]
    });


    this.service.searchGrupoById(this.grupoId)
      .subscribe(response => this.grupoDescription = response['descricao'])

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.fillUsers();

  }

  fillUsersGroup() {
    let params: HttpParams = new HttpParams();
    params = params.append('perfilAcessoId', this.grupoId)
    return this.service.searchUsersGroup(params)
      .toPromise();
  }


  fillListAllUsers() {
    let params: HttpParams = new HttpParams();
    return this.service.searchUsers(params)
      .toPromise();
  }

  async fillUsers() {
    this.spinnerLoad = true;
    this.listUsersGroup = await this.fillUsersGroup();
    if (this.listUsersGroup == null) this.listUsersGroup = [];

    this.listUsersGroup = this.listUsersGroup.map(function (value) {
      return { id: value.id, descricao: String(value.login).toUpperCase() }
    });


    this.listUsers = await this.fillListAllUsers();
    if (this.listUsers==null) this.listUsers = [];

    this.listUsers = this.listUsers.map(function (value) {
      return { id: value.id, descricao: String(value.login).toUpperCase() }
    });

    this.listUsers = this.diffListMenus(this.listUsers, this.listUsersGroup);

    this.spinnerLoad = false;

  }



  diffListMenus(list1: any, list2: any) {

    list2.forEach(element => {
      list1 = list1.filter(value => value.id != element.id);
    });

    return list1;
  }


  saveGrupoMenu() {
    let data = this.formMenusGrupo.value;

    let dataPersist = {
      perfilAcessoId: data.grupoId,
      acessoIds: this.listUsersGroup.map(function (grupoMenu) {
        return grupoMenu.id
      })
    }

    this.spinnerLoad = true
    this.service.saveUsersGroup(
      dataPersist,
      (resp) => {
        this.spinnerLoad = false
        this.notifications.success('Registro Salvo com sucesso!');
      }, (error) => {
        this.spinnerLoad = false
        this.notifications.error(error.message);
      })

  }

  previousPage() {
    this.location.back();
  }

  cancel() {
    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
